import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ProgressBar from '../../../../components/progress-bar';
import OpportunityTable from '../../../Analysic/components/table/opportunity-table';
import AccountTable from '../../../Dashboard/components/AccountTable';
import ContactNameRenderer from '../../../../components/table-cells/ContactNameRenderer';
import EmailRenderer from '../../../../components/table-cells/EmailRenderer';
import ResourceTable from '../resource-table';

import {
  fetchFeedbackProgressContacts,
} from '../../../Dashboard/DashboardActions';


import {
  getContactProgressLoading,
  getContactProgressLoaded,
  getContactProgressErrors,
  getProgressContacts,
} from '../../../Dashboard/DashboardReducer';



class ContactList extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
    this.loadData();
    this.getColDefs = this.getColDefs.bind(this);
    this.columnContactValueGetter = this.columnContactValueGetter.bind(this);
  }

  loadData() {
    const { automation, ids } = this.props;
    this.props.dispatch(fetchFeedbackProgressContacts(automation._id, automation.source, ids));
  }


  columnContactValueGetter(params) {
    if (params.node.group) {
      // groupping
      return null;
    }
    const { data } = params;
    return `${data.first_name} ${data.last_name}`;
  }

  getColumn(column, field) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      field,
      enableRowGroup: true,
      enablePivot: true,
      cellRendererParams: {
        column,
      },
    };
  }

  getContactColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      enableRowGroup: true,
      enablePivot: true,
      valueGetter: this.columnContactValueGetter,
      cellRenderer: ContactNameRenderer,
      cellRendererParams: {
        column,
      },
    };
  }


  getEmailColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      enableRowGroup: true,
      enablePivot: true,
      field: 'email',
      cellRenderer: EmailRenderer,
      cellRendererParams: {
        column,
      },
    };
  }

  getOutreachColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      enableRowGroup: true,
      enablePivot: true,
      field: 'outreach_step',
      cellRendererParams: {
        column,
      },
    };
  }

  getColDefs(tableColumn) {
    if (tableColumn.tag === 'contact') {
      return this.getContactColumn(tableColumn);
    }
    if (tableColumn.tag === 'title') {
      return this.getColumn(tableColumn, 'title');
    }
    if (tableColumn.tag === 'email') {
      return this.getEmailColumn(tableColumn);
    }
    if (tableColumn.tag === 'outreach') {
      return this.getOutreachColumn(tableColumn);
    }

    return ResourceTable.getColDefs(tableColumn);
  }

  renderResults() {
    const { automation, contacts } = this.props;
    const isAccount = automation.source === 'account';

    if (!contacts || contacts.length === 0) {
      return (
        <div className="alert alert-warning">
          No contacts found.
        </div>
      );
    }
    if (isAccount) {
      return (
        <AccountTable
          tableName="progress-account-contact-table"
          title={null}
          getColDefs={this.getColDefs}
          accounts={contacts}
        />
      );
    }
    return (
      <OpportunityTable
        opportunities={contacts}
        tableName="progress-opportunity-contact-table"
        title={null}
        getColDefs={this.getColDefs}
      />
    );
  }

  render() {
    const {
      loaded, loading,
    } = this.props;
    const isLoading = !loaded || loading;

    return (
      <div>
        {isLoading && <ProgressBar />}
        {loaded && !loading && this.renderResults()}
      </div>
    );
  }
}


// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    loading: getContactProgressLoading(state),
    loaded: getContactProgressLoaded(state),
    errors: getContactProgressErrors(state),
    contacts: getProgressContacts(state),
  };
}

ContactList.propTypes = {
  dispatch: PropTypes.func.isRequired,
  ids: PropTypes.arrayOf(PropTypes.string),
  automation: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    source: PropTypes.string.isRequired,
  }).isRequired,
  loading: PropTypes.bool,
  loaded: PropTypes.bool,
  errors: PropTypes.shape({}),
  contacts: PropTypes.arrayOf(PropTypes.shape({})),
};

ContactList.defaultProps = {
  ids: [],
  loading: false,
  loaded: false,
  errors: null,
  contacts: [],
};

ContactList.contextTypes = {
  addNotification: PropTypes.func.isRequired,
};
export default connect(mapStateToProps)(ContactList);
